export { default } from './ClientErrorBoundary';
